// extracted by mini-css-extract-plugin
export default {"accordionbutton":"sideBar_accordionbutton__MKTsv","accordionbody":"sideBar_accordionbody__1Bp6z","adminTxt":"sideBar_adminTxt__88lwy","adminTxtDiv":"sideBar_adminTxtDiv__WEsbx"};